module.exports = __webpack_public_path__ + "img/hero.8be5bdab.webp";